import React, { useState } from "react";
import { ChildrenProps } from "../models/componentModel";
import { globalIntegration, globalIntegrationType, globalSlackIntegration, createZohoIntegrationOrganizationChatbotAssignmentInterface, zohoDepartment, zohoIntegrationList, zohoTicketFields, zohoContact, metaIntegrationFaceBookDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew, zohoTicketLogs, getMetaIntegrationResponseNew, whatsappTryNowNumbersResponse, UserMeResponseDataModel, CommonResponseSecondaryModel, CommonResponseModel } from "../models/axiosModel";
import agent from "../services/api";
import { WhatsappFlow } from "../components/dashboard/channels/global/whatsapp/flows/waFlowTypes";
import { extractIntegrationsFromResponse, formatDateAccordingToTimezoneUsingMoment, sortListByRecentTimestamp } from "../utils/constants";

const IntegrationContext = React.createContext<IntegrationContextPayload | undefined>(undefined);



export interface IntegrationContextPayload {
    integrationList: getMetaIntegrationResponseNew[] | null,
    setIntegrationList: React.Dispatch<React.SetStateAction<getMetaIntegrationResponseNew[] | null>>,
    getIntegrationList: (flag_cancel_meta_integration_sync?: boolean) => Promise<any>,
    globalIntegrationTypeList: globalIntegrationType[],
    setGlobalIntegrationTypeList: React.Dispatch<React.SetStateAction<globalIntegrationType[]>>,
    getGlobalIntegrationTypeList: any,
    integrationDetails: metaIntegrationWhatsAppDataNew | null,
    setIntegrationDetails: React.Dispatch<React.SetStateAction<metaIntegrationWhatsAppDataNew | null>>,

    facebookIntegrationDetails: (metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) | null,
    setFacebookIntegrationDetails: React.Dispatch<React.SetStateAction<(metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) | null>>,
    slackIntegrations: globalSlackIntegration[] | null,
    setSlackIntegrations: React.Dispatch<React.SetStateAction<globalSlackIntegration[] | null>>
    getSlackIntegrations: () => Promise<CommonResponseModel<globalSlackIntegration>>;
    zohoIntegrations: zohoIntegrationList[] | null;
    getZohoIntegrations: () => Promise<CommonResponseModel<zohoIntegrationList>>;
    zohoTicketFields: zohoTicketFields[] | null;
    setZohoTicketFields: React.Dispatch<React.SetStateAction<zohoTicketFields[] | null>>;
    getZohoTicketFieldsApi: (zoho_integration_id: number | null) => Promise<any>;
    createZohoIntegrationOrganizationChatbotAssignmentApi: (payload: createZohoIntegrationOrganizationChatbotAssignmentInterface) => Promise<any>,
    deleteZohoIntegrationChatbotAssignmentApi: (zoho_integration_organization_chatbot_id: number) => Promise<any>,
    zohoContact: zohoContact[] | null,
    setZohoContact: React.Dispatch<React.SetStateAction<zohoContact[] | null>>,
    zohoDepartment: zohoDepartment[] | null,
    setZohoDepartment: React.Dispatch<React.SetStateAction<zohoDepartment[] | null>>,
    zohoTicketLogs: zohoTicketLogs[] | null,
    setZohoTicketLogs: React.Dispatch<React.SetStateAction<zohoTicketLogs[] | null>>,
    getListOfZohoContactApi: (zoho_integration_organization_id: number) => Promise<any>,
    getListOfZohoDepartmentApi: (zoho_integration_organization_id: number) => Promise<any>,
    setZohoIntegrations: React.Dispatch<React.SetStateAction<zohoIntegrationList[] | null>>
    integrationListNewStructure: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[] | null,
    setIntegrationListNewStructure: React.Dispatch<React.SetStateAction<(metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[] | null>>,
    getMetaIntegrationList: (flag_cancel_meta_integration_sync?: boolean) => Promise<any>,
    getZohoTicketLogsApi: (zoho_integration_id: number) => Promise<any>,
    whatsappNumberTry: whatsappTryNowNumbersResponse,
    setWhatsappNumberTry: React.Dispatch<React.SetStateAction<whatsappTryNowNumbersResponse>>,

    flowList: WhatsappFlow[] | null, 
    setFlowList: React.Dispatch<React.SetStateAction<WhatsappFlow[] | null>>,
    getWAFlowList: (userDetail: UserMeResponseDataModel, wabaId: string) => Promise<CommonResponseSecondaryModel<WhatsappFlow>>,
}

const initialWhatsappNumberTry = {
    meta_integration_try_now_phone_number_id: "",
    waba_id: "",
    waba_name: "",
    phone_number_id: "",
    verified_name: "",
    display_phone_number: "",
    created_at_timestamp: "",
}

const IntegrationProvider = ({ children }: ChildrenProps) => {
    const [globalIntegrationTypeList, setGlobalIntegrationTypeList] = useState<globalIntegrationType[]>([])
    const [integrationList, setIntegrationList] = useState<getMetaIntegrationResponseNew[] | null>(null);
    // const [integrationDetails, setIntegrationDetails] = useState(null)
    const [integrationDetails, setIntegrationDetails] = useState<metaIntegrationWhatsAppDataNew | null>(null);
    const [slackIntegrations, setSlackIntegrations] = useState<null | globalSlackIntegration[]>(null)
    // const [facebookIntegrationDetails, setFacebookIntegrationDetails] = useState(null)

    const [zohoIntegrations, setZohoIntegrations] = useState<zohoIntegrationList[] | null>(null)
    const [zohoTicketFields, setZohoTicketFields] = useState<zohoTicketFields[] | null>(null);
    const [zohoContact, setZohoContact] = useState<zohoContact[] | null>(null);
    const [zohoDepartment, setZohoDepartment] = useState<zohoDepartment[] | null>(null);
    const [zohoTicketLogs, setZohoTicketLogs] = useState<zohoTicketLogs[] | null>(null);

    const [facebookIntegrationDetails, setFacebookIntegrationDetails] = useState<(metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) | null>(null)
    const [integrationListNewStructure, setIntegrationListNewStructure] = useState<(metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[] | null>(null)

    const [whatsappNumberTry, setWhatsappNumberTry] = useState<whatsappTryNowNumbersResponse>(initialWhatsappNumberTry);
    const [flowList, setFlowList] = useState<WhatsappFlow[] | null>(null);

    const getIntegrationList = async (flag_cancel_meta_integration_sync = false): Promise<globalIntegration[] | null> => {
        const response = await agent.getMetaIntegration.get("", flag_cancel_meta_integration_sync);
        getSlackIntegrations()
        getZohoIntegrations()
        if (response.status) {
            if (response.data.length > 0) {
                const integrationList = extractIntegrationsFromResponse(response.data);
                setIntegrationListNewStructure(integrationList);
            } else {
                setIntegrationListNewStructure(response.data)
            }
            setIntegrationList(response.data)
        }
        return response;
    }

    const getMetaIntegrationList = async (flag_cancel_meta_integration_sync = false): Promise<any> => {
        const res = await agent.getMetaIntegration.get("", flag_cancel_meta_integration_sync);
        if (res.status) {
            if (res.data.length > 0) {
                const integrationList = extractIntegrationsFromResponse(res.data);
                setIntegrationListNewStructure(integrationList);
            } else {
                setIntegrationListNewStructure(res.data)
            }
            setIntegrationList(res.data)
        }
        return res;
    }

    const getSlackIntegrations = async () => {
        const slackResponse = await agent.getSlackintegrations.get();
        if (slackResponse.status) {
            setSlackIntegrations(slackResponse.data)
        }
        return slackResponse;
    }
    const getZohoIntegrations = async () => {
        const zohoIntegrations = await agent.getZohoIntegration.get();
        if (zohoIntegrations.status) {
            setZohoIntegrations(zohoIntegrations.data)
        }
        return zohoIntegrations;
    }

    const getZohoTicketFieldsApi = async (zoho_integration_id: number | null) => {
        const res = await agent.getZohoTicketFields.get(zoho_integration_id);
        if (res.status) {
            setZohoTicketFields(res.data);
        }
        return res;
    }

    const createZohoIntegrationOrganizationChatbotAssignmentApi = async (payload: createZohoIntegrationOrganizationChatbotAssignmentInterface) => {
        const res = await agent.createZohoIntegrationOrganizationChatbotAssignment.post(payload);
        return res;
    }

    const deleteZohoIntegrationChatbotAssignmentApi = async (zoho_integration_organization_chatbot_id: number) => {
        const res = await agent.deleteZohoIntegrationChatbotAssignment.delete(zoho_integration_organization_chatbot_id);
        return res;
    }

    const getListOfZohoContactApi = async (zoho_integration_organization_id: number) => {
        const res = await agent.getListOfZohoContact.get(zoho_integration_organization_id);
        if (res.status) {
            setZohoContact(res.data);
        } else {
            setZohoContact(null);
        }
        return res;
    }

    const getListOfZohoDepartmentApi = async (zoho_integration_organization_id: number) => {
        const res = await agent.getListOfZohoDepartment.get(zoho_integration_organization_id);
        if (res.status) {
            setZohoDepartment(res.data);
        } else {
            setZohoDepartment(null);
        }
        return res;
    }

    const getZohoTicketLogsApi = async (zoho_integration_id: number): Promise<any> => {
        const res = await agent.getZohoTicketLogs.get(zoho_integration_id);
        if (res.status) {
            setZohoTicketLogs(res.data);
        } else {
            setZohoTicketLogs(null);
        }
        return res;
    }

    const getGlobalIntegrationTypeList = async () => {
        const responseMetaIntegration = await agent.getChannelList.get();
        const responseIntegration = await agent.getIntegrations.get();
        if (responseMetaIntegration.status && responseIntegration.status) {
            let temp = [...responseMetaIntegration.data]
            let temp1 = [...responseIntegration.data]
            temp1 = temp1.filter((integration) => integration.integration_app_name !== "Calendly")
            setGlobalIntegrationTypeList([...temp, ...temp1])
        } else {
            setGlobalIntegrationTypeList([])
        }
    }

    const getWAFlowList = async (userDetail: UserMeResponseDataModel, wabaId: string) => {
        const res = await agent.getWAFlowList.get(wabaId);
        if (res.status && res.data) {
            if (res?.data?.length > 0) {
                let waFlowList = res.data.map((flowData: WhatsappFlow) => {
                    return {
                        ...flowData,
                        whatsapp_flow_meta_status: flowData?.whatsapp_flow_version_data?.[0]?.whatsapp_flow_metadata_response?.whatsapp_flow_meta_status,
                        timestamp: formatDateAccordingToTimezoneUsingMoment(flowData?.whatsapp_flow_version_data?.[0]?.timestamp, userDetail.timezone_hour)
                    }
                })
                waFlowList = sortListByRecentTimestamp(waFlowList, "timestamp");
                setFlowList(waFlowList)
            }
        } else {
            setFlowList(null);
        }
        return res;
    }

    const payload = {
        integrationList,
        setIntegrationList,
        getIntegrationList,
        globalIntegrationTypeList,
        setGlobalIntegrationTypeList,
        getGlobalIntegrationTypeList,
        integrationDetails,
        setIntegrationDetails,
        facebookIntegrationDetails,
        setFacebookIntegrationDetails,
        slackIntegrations,
        setSlackIntegrations,
        getSlackIntegrations,
        getZohoIntegrations,
        zohoIntegrations,
        setZohoIntegrations,
        zohoTicketFields,
        setZohoTicketFields,
        getZohoTicketFieldsApi,
        createZohoIntegrationOrganizationChatbotAssignmentApi,
        deleteZohoIntegrationChatbotAssignmentApi,
        zohoContact,
        setZohoContact,
        zohoDepartment,
        setZohoDepartment,
        zohoTicketLogs,
        setZohoTicketLogs,
        getListOfZohoContactApi,
        getListOfZohoDepartmentApi,
        integrationListNewStructure,
        setIntegrationListNewStructure,
        getMetaIntegrationList,
        getZohoTicketLogsApi,
        whatsappNumberTry,
        setWhatsappNumberTry,
        flowList, 
        setFlowList,
        getWAFlowList
    };

    return (
        <IntegrationContext.Provider value={payload}>
            {children}
        </IntegrationContext.Provider>
    );
};

export { IntegrationContext, IntegrationProvider };
